<template>
  <div>
    <!-- 条件选择后渲染的充电站列表 -->
    <div
      v-for="(marker, index) in markersStation"
      :key="index"
      class="list-item _flexcol"
      @click="gotoChargeDetail(marker)"
    >
      <div class="list-left">
        <p class="park-name">
          <span v-if="marker.openState && marker.openState.text">{{ marker.openState.text }}</span>
          {{ marker.stationName }}
        </p>
        <!-- <p v-if="marker.projectName" class="text-xs">{{ marker.projectName }}</p> -->
        <div class="text-sm flex flex-row items-center address-content">
          <p>{{ marker.stationAddr }}</p>
        </div>
        <div class="tip-content text-xs text-gray-500 mb-1">
          <span v-if="marker.supportBook === 1" class="tip-border-sub ">可预约</span>
          <span v-if="marker.supportOccupy === 1" class="tip-border-sub ">占桩费</span>
          <i v-if="marker.supportBook === 1 && marker.usageRate" class="border-drivder" />
          <span v-if="marker.usageRate" class="tip-sub text-gray-300">{{ marker.usageRate }}</span>
        </div>
        <div class="station_price my-1">
          <span>{{ marker.currentPrice }}</span><span>&nbsp;元/度</span>
        </div>
        <div class="stations">
          <div v-if="marker.quickChargingInfo.totalNum !== 0" class="img-charging ">
            <img src="./../../assets/map/快充面.png">
            <p class="quickCharging">
              <span>{{ marker.quickChargingInfo.leftNum }}/</span><span>{{ marker.quickChargingInfo.totalNum
              }}</span>
            </p>
          </div>
          <div v-if="marker.slowChargingInfo.totalNum !== 0" class="img-charging">
            <img src="./../../assets/map/慢充面.png">
            <p class="slowCharging">
              <span>{{ marker.slowChargingInfo.leftNum }}/</span><span>{{ marker.slowChargingInfo.totalNum
              }}</span>
            </p>
          </div>
        </div>
        <div class="text-xs flex flex-row items-center text-gray-300">
          <img :src="payIcon" alt="" class="pay-img">
          <p style="margin-top:2px">{{ marker.parkingFeeDesc || '具体收费规则以现场为准' }}</p>
        </div>
      </div>
      <!--导航-->
      <div class="list-right" @click.stop="openBMap(marker)">
        <img src="./../../assets/map/navigation.png" class="list-right-img">
        <div class="list-right-center">{{ marker.distance | changeNum }}</div>
      </div>
    </div>

    <div v-if="!markersStation.length">
      <div class="no-marker-list">
        <div class="img-wrapper">
          <img src="../../assets/order_no-permission.png">
        </div>
        <p>暂无符合条件的充电站</p>
      </div>
    </div>

    <!-- 充电站地图导航 -->
    <div v-if="goMap" id="androidDialog2" class="js_dialog" style="opacity: 1">
      <div class="weui-mask" />
      <div class="weui-dialog weui-skin_android">
        <div class="weui-dialog__bd">确定对该充电站进行导航么？</div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_default" @click.stop="goMap = false">取消</a>
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click.stop="primary('高德')"
          >高德地图</a>
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click.stop="primary('百度')"
          >百度地图</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { JumpToMapApp } from '@/utils/index.js'

export default {
  components: { },
  filters: {
    changeNum(val) {
      let num
      val > 999 ? (num = `${(val / 1000).toFixed(2)}km`) : (num = `${val}m`)
      return num
    }
  },
  props: {
    markersStation: {
      type: Array,
      default: () => []
    },
    mapFlag: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      addressIcon: require('@/assets/chargingPlatform/icon-address.png'),
      payIcon: require('@/assets/map/停车收费.png'),
      goMap: false,
      parkItem: ''
    }
  },
  computed: {
  },
  watch: {},
  created() {},
  mounted() {
  },
  methods: {
    openBMap(item) {
      this.parkItem = item
      if (this.mapFlag == 1) {
        this.primary('高德')
      } else if (this.mapFlag == 2) {
        this.primary('百度')
      } else if (this.mapFlag == 3) {
        this.goMap = true
      }
    },
    gotoChargeDetail(marker) {
      this.$emit('gotoChargeDetail', marker.stationId)
    },
    primary(val) {
      this.goMap = false
      const originPos = {
        lat: localStorage.getItem('lat'),
        lng: localStorage.getItem('lng')
      }
      JumpToMapApp(
        originPos,
        { lat: this.parkItem.latitude, lng: this.parkItem.longitude },
        this.parkItem.stationName,
        val
      )
      // let url = `http://api.map.baidu.com/direction?origin=latlng:${originPos.lat},${originPos.lng}|name:我的位置&destination=latlng:${item.latitude},${item.longitude}|name:${item.parkingName}&mode=driving&output=html&src=Hikvision|HikParking&coord_type=wgs84`;
      // window.location.href = url;
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/tailwindcss.less';
        .list-item {
          padding-bottom: 20px;
          margin-top: 16px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.04);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          &._flexcol{
            flex-direction: row;
          }

            .park-name {
              font-size: 16px;
              color: #333;
              font-weight: bold;
              &._gray{
                color: #999999;
              }
            }

            .park-add {
              font-size: 14px;
              color: #666;
              margin-top: 3px;
            }

            .station_price {
              span:nth-child(1) {
                font-size: 16px;
                font-weight: 500;
              }

              span:nth-child(2) {
                font-size: 14px;
                color: #999999;
              }
            }

            .dis-flex {
              display: flex;
            }
            p{
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          .list-left{
            width: 80%;
          .stations {
            display: flex;
            margin-bottom: 5px;

            .img-charging {
              display: flex;
              font-size: 12px;
              color: #999999;
              text-align: center;

              p {
                padding: 0px 6px;
                height: 25px;
                line-height: 25px;

                span:nth-child(1) {
                  font-size: 14px;
                  color: #3880FF;
                }
              }
            }
            .img-charging:nth-child(2){
              margin-left: 8px;
            }

            .quickCharging {
              background: url("./../../assets/map/快充线.png") center no-repeat;
              background-size: 100% 100%;
              min-width: 50px;
            }
              .slowCharging {
                background: url("./../../assets/map/慢充线.png") center no-repeat;
                background-size: 100% 100%;
                min-width: 50px;
              }

            img {
              width: 40px;
              height: 25px;
            }
          }
          }
          .list-right {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;

            .list-right-img {
              width: 16px;
              height: 16px;
              margin-right: 2px;
            }

            .list-right-center {
              font-size: 12px;
              color: #666666;
              letter-spacing: 0;
            }
          }
        }

      .no-marker-list {
        color: #666;
        font-size: 14px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        flex-direction: column;

        &:before {
          content: "";
          display: table;
        }

        .img-wrapper {
          width: 100px;
          height: 100px;
          margin: 40px auto 20px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
  .tip-content {
    display: flex;
    flex-direction: row;
    margin-top: 4px;
    align-items: center;
    .tip-border-sub {
      border: 1px solid rgba(151, 151, 151, 1);
      border-radius: 4px;
      padding: 1px 6px;
      margin-right: 4px;
      line-height: 20px;
    }
    .border-drivder {
      display: inline-block;
      width: 1px;
      height: 12px;
      background: #999;
      margin-left: 4px;
      margin-right: 8px;
    }
  }
    .pay-img{
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
  .address-content {
    margin-top: 4px;
    .adderss-img {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
  }
</style>
